// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TOAA2YqO_lUqBz {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  border-radius: var(--ds-border-radius-200, 8px);
}
.TOAA2YqO_lUqBz:hover {
  background-color: var(--ds-background-neutral, #091e420f);
}
.VeLarJA7l6QBxh:hover {
  background-color: var(--ds-background-neutral-subtle-hovered, hsla(0, 0%, 0%, 0.08));
}
.kh_GDukOPRaeIL {
  display: inline-block;
  position: relative;
  flex: 0 0 auto;
  width: 40px;
  height: 32px;
  border-radius: var(--ds-border-radius-100, 4px);
  opacity: 1;
  background-size: cover;
}
.wKfvpdKzATW0pV {
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-100, 8px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.eUponOV8Ppxomw {
  flex-direction: column;
  padding-top: var(--ds-space-0, 0);
  padding-bottom: var(--ds-space-0, 0);
}
.Wtsfz3ul0uKF48 {
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 18px;
}
._8tzefEveYo3Y1 {
  color: var(--ds-text-subtlest, #626f86);
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 16px;
}
.Wtsfz3ul0uKF48,
._8tzefEveYo3Y1 {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vpOgMbbhTRrWIZ {
  position: absolute;
  top: var(--ds-space-negative-050, -4px);
  left: 35px;
  width: 8px;
  height: 8px;
  border: 2px solid var(--ds-surface, #ffffff);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-icon-brand, #0c66e4);
}
.NNygaHnD4AIbdW {
  display: flex;
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  width: 0;
  height: 40px;
}
.NNygaHnD4AIbdW.jy3pPkO8THwxuP {
  width: auto;
}
.tFNnxuIYQM_8UL {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0;
  overflow: hidden;
}
.tFNnxuIYQM_8UL.jy3pPkO8THwxuP {
  width: 24px;
}
.F3nJVJ7XsoLFqU {
  display: flex;
  flex: 1;
  height: 32px;
  padding: var(--ds-space-050, 4px) var(--ds-space-100, 8px) var(--ds-space-050, 4px) var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-200, 8px);
  font-weight: var(--ds-font-weight-bold, 700);
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
}
.F3nJVJ7XsoLFqU:hover,
.F3nJVJ7XsoLFqU:focus,
.F3nJVJ7XsoLFqU:focus-within {
  text-decoration: none;
}
.F3nJVJ7XsoLFqU.jy3pPkO8THwxuP {
  padding-right: var(--ds-space-300, 24px);
}
.TOAA2YqO_lUqBz:hover .F3nJVJ7XsoLFqU,
.TOAA2YqO_lUqBz:focus .F3nJVJ7XsoLFqU,
.TOAA2YqO_lUqBz:focus-within .F3nJVJ7XsoLFqU {
  padding-right: var(--ds-space-300, 24px);
}
.TOAA2YqO_lUqBz:hover .vpOgMbbhTRrWIZ.HR5jx9fdSzgv5x,
.TOAA2YqO_lUqBz:focus .vpOgMbbhTRrWIZ.HR5jx9fdSzgv5x,
.TOAA2YqO_lUqBz:focus-within .vpOgMbbhTRrWIZ.HR5jx9fdSzgv5x {
  margin-right: var(--ds-space-050, 4px);
}
.TOAA2YqO_lUqBz:hover .NNygaHnD4AIbdW,
.TOAA2YqO_lUqBz:focus .NNygaHnD4AIbdW,
.TOAA2YqO_lUqBz:focus-within .NNygaHnD4AIbdW {
  width: auto;
}
.TOAA2YqO_lUqBz:hover .tFNnxuIYQM_8UL,
.TOAA2YqO_lUqBz:focus .tFNnxuIYQM_8UL,
.TOAA2YqO_lUqBz:focus-within .tFNnxuIYQM_8UL {
  display: flex;
  overflow: visible;
}
.TOAA2YqO_lUqBz:hover .tFNnxuIYQM_8UL.xl2yaMIgTwF9sI,
.TOAA2YqO_lUqBz:focus .tFNnxuIYQM_8UL.xl2yaMIgTwF9sI,
.TOAA2YqO_lUqBz:focus-within .tFNnxuIYQM_8UL.xl2yaMIgTwF9sI {
  width: 24px;
}
.VxwBwS3gI90USM {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  padding: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.sAI01mpCE3p6Nn {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
`, ""]);
// Exports
export var boardTile = `TOAA2YqO_lUqBz`;
export var relatedTemplates = `VeLarJA7l6QBxh`;
export var boardThumbnail = `kh_GDukOPRaeIL`;
export var boardDescription = `wKfvpdKzATW0pV`;
export var fullHeight = `eUponOV8Ppxomw`;
export var boardName = `Wtsfz3ul0uKF48`;
export var boardSubName = `_8tzefEveYo3Y1`;
export var unreadMarker = `vpOgMbbhTRrWIZ`;
export var actionsWrapper = `NNygaHnD4AIbdW`;
export var isStarred = `jy3pPkO8THwxuP`;
export var utilityAction = `tFNnxuIYQM_8UL`;
export var boardLink = `F3nJVJ7XsoLFqU`;
export var isUnread = `HR5jx9fdSzgv5x`;
export var actionSmall = `xl2yaMIgTwF9sI`;
export var boardTemplateBadgeContainer = `VxwBwS3gI90USM`;
export var boardTemplateBadge = `sAI01mpCE3p6Nn`;
export default ___CSS_LOADER_EXPORT___;
